/**
 * Stitch design tokens + helpers voor de strategie-pagina.
 * Hergebruikt dezelfde palette als adminSettingsCommon.jsx.
 */
import React from 'react';

export const T = {
  primary: '#526075', primaryDim: '#465469',
  tertiary: '#635983', tertiaryContainer: '#dbcdff',
  primaryContainer: '#d5e3fd',
  bg: '#f8f9fa',
  surface: '#ffffff', surfaceLow: '#f1f4f5', surfaceHigh: '#e5e9eb',
  text: '#2d3335', secondary: '#556071',
  outline: '#767c7e', outlineVariant: '#adb3b5',
  emerald: '#10b981', emeraldBg: '#ecfdf5',
  amber: '#f59e0b', amberBg: '#fef3c7',
  rose: '#ec4899', roseBg: '#fce7f3',
  violet: '#7c3aed', violetBg: '#ede9fe',
  blue: '#3b82f6', blueBg: '#dbeafe',
  red: '#ef4444', redBg: '#fee2e2',
  slate: '#64748b', slateBg: '#f1f5f9',
  shadow: '0 1px 3px rgba(45,51,53,0.04)',
  font: '"Manrope", system-ui, sans-serif',
  fontBody: '"Inter", system-ui, sans-serif',
};

export const Icon = ({ name, size = 22, fill, sx = {} }) => (
  <span
    className="material-symbols-outlined"
    style={{
      fontSize: size,
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' 500, 'GRAD' 0, 'opsz' ${size}`,
      lineHeight: 1,
      ...sx,
    }}
  >
    {name}
  </span>
);

export const ROCK_STATUS = {
  on_track:  { label: 'Op schema',  color: T.emerald, bg: T.emeraldBg },
  at_risk:   { label: 'Risico',     color: T.amber,   bg: T.amberBg },
  off_track: { label: 'Achter',     color: T.red,     bg: T.redBg },
  done:      { label: 'Klaar',      color: T.blue,    bg: T.blueBg },
  paused:    { label: 'Gepauzeerd', color: T.slate,   bg: T.slateBg },
};

export const STAGE_INFO = {
  idee:            { label: 'Idee',            color: T.slate,   bg: T.slateBg,   step: 1 },
  in_ontwikkeling: { label: 'In ontwikkeling', color: T.amber,   bg: T.amberBg,   step: 2 },
  beta:            { label: 'Beta',            color: T.violet,  bg: T.violetBg,  step: 3 },
  live:            { label: 'Live',            color: T.emerald, bg: T.emeraldBg, step: 4 },
  sunset:          { label: 'Sunset',          color: T.outlineVariant, bg: T.surfaceHigh, step: 5 },
};

export const URGENCY_INFO = {
  low:    { label: 'Laag',    color: T.slate,   bg: T.slateBg },
  normal: { label: 'Normaal', color: T.blue,    bg: T.blueBg },
  high:   { label: 'Hoog',    color: T.red,     bg: T.redBg },
};

export const RR_STATUS = {
  open:        { label: 'Open',          color: T.amber,   bg: T.amberBg },
  in_progress: { label: 'In behandeling', color: T.blue,    bg: T.blueBg },
  decided:     { label: 'Besloten',      color: T.emerald, bg: T.emeraldBg },
  rejected:    { label: 'Afgewezen',     color: T.outlineVariant, bg: T.surfaceHigh },
};

export const DISCIPLINES = [
  { key: 'sales',     label: 'Sales',     icon: 'trending_up', color: T.blue,    bg: T.blueBg },
  { key: 'marketing', label: 'Marketing', icon: 'campaign',    color: T.rose,    bg: T.roseBg },
  { key: 'hr',        label: 'HR',        icon: 'group',       color: T.violet,  bg: T.violetBg },
];

export function relativeTime(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const ms = now - d;
  const days = Math.floor(ms / 86400000);
  if (days < 1) return 'vandaag bijgewerkt';
  if (days === 1) return 'gisteren bijgewerkt';
  if (days < 7) return `${days} dagen geleden bijgewerkt`;
  if (days < 14) return '1 week geleden bijgewerkt';
  if (days < 30) return `${Math.floor(days / 7)} weken geleden bijgewerkt`;
  if (days < 60) return '1 maand geleden bijgewerkt';
  return `${Math.floor(days / 30)} maanden geleden bijgewerkt`;
}

export function formatDate(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' });
}
